import { InterfaceProjectsInDevelopment } from '../../interfaces/ProjectsInDevelopment/interfaceProjectsInDevelopment';
import api from '../ServiceBase';

export const getProjectsInDevelopment = async () => {
  const { data } = await api.get<InterfaceProjectsInDevelopment[]>('projeto-em-desenvolvimento');
  return data;
};
